

define(['./select-shipping/directive', './add-shipping/directive', './delete-shipping/directive', './update-shipping/directive', './shipping-address/directive'], function () {});


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/select-shipping/directive.js
// module id = ./components/xo-member-components/src/select-shipping/directive.js
// module chunks = 1